
import { Vue, Component } from "vue-property-decorator";
import {commitSwitchLanguage} from "@/store/admin/mutations";
import {readLanguage} from "@/store/admin/getters";
import pdf from "vue-pdf";
import {api} from "@/api";
import {readToken} from "@/store/main/getters";
//import Anleitung from "@/assets/anleitung.pdf"


@Component({
  components: {pdf},
})
export default class Visit extends Vue {
public pageCount = 3;
//pdfURL = Anleitung;

  public download() {
    var win = window.open("declaration.pdf","Datenschutzerklärung.pdf");
    // setTimeout(function(){ win.document.title = 'Maggie.pdf'; }, 1000);
  }

  public async mounted() {
    

  }
 


}
